import { Button, useToast } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { startImpersonation } from '../utils/impersonation'

interface Props {
  userId: string
  userName: string
}

export default function ImpersonateButton({ userId, userName }: Props) {
  const { t } = useTranslation()
  const toast = useToast()
  const [loading, setLoading] = useState(false)

  const handleImpersonate = async () => {
    setLoading(true)
    try {
      await startImpersonation(userId, userName)
      // Pas de setLoading(false) en cas de succès : la page se recharge
      // entièrement, le composant ne reverra jamais ce rendu.
    } catch (error) {
      setLoading(false)
      toast({
        title: t('SuperAdmin.users.impersonateError'),
        description: error instanceof Error ? error.message : undefined,
        status: 'error',
        duration: 6000,
        isClosable: true,
      })
    }
  }

  return (
    <Button
      size="xs"
      variant="outline"
      isLoading={loading}
      onClick={handleImpersonate}
    >
      {t('SuperAdmin.users.impersonate')}
    </Button>
  )
}
